var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutomaticUpdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 63.996,
    viewBox: "0 0 64 63.996",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-7284278",
    transform: "translate(-11.241 -11.243)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47420",
    "data-name": "Path 47420",
    d: "M39.643,52.943a2.581,2.581,0,0,0,1.868-.76L55.693,38.052a2.593,2.593,0,0,0-3.665-3.665L39.643,46.7l-5.189-5.189a2.608,2.608,0,0,0-3.665,0,2.573,2.573,0,0,0,0,3.665l7.023,7.04h0a2.649,2.649,0,0,0,1.834.726Z",
    fill: "#0b6972"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47421",
    "data-name": "Path 47421",
    d: "M12.591,52.494a1.733,1.733,0,0,0,1.73,1.23,2.506,2.506,0,0,0,.5,0,1.735,1.735,0,0,0,1.159-2.162A28.555,28.555,0,0,1,43.241,14.7a28.205,28.205,0,0,1,17.174,5.76l.449.365-2.54,0a1.73,1.73,0,1,0,0,3.459h7a1.724,1.724,0,0,0,1.73-1.73V15.567a1.73,1.73,0,1,0-3.459,0V18.61c-.365-.311-.726-.6-1.108-.882h0a31.639,31.639,0,0,0-19.252-6.486A32.051,32.051,0,0,0,12.59,52.493Z",
    fill: "#0b6972"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47422",
    "data-name": "Path 47422",
    d: "M73.891,33.988a1.74,1.74,0,0,0-3.321,1.037A28.556,28.556,0,0,1,43.241,71.78a28.205,28.205,0,0,1-17.174-5.76l-.449-.294h2.54a1.73,1.73,0,0,0,0-3.459h-7A1.729,1.729,0,0,0,19.425,64v6.919a1.73,1.73,0,0,0,3.459,0V67.9c.365.311.726.6,1.108.882h0a31.622,31.622,0,0,0,19.252,6.452,32.051,32.051,0,0,0,30.651-41.25Z",
    fill: "#0b6972"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomaticUpdate);
export default __webpack_public_path__ + "static/media/automatic-update.df7b1ee0b6bd792d6a4aa4505479192c.svg";
export { ForwardRef as ReactComponent };